import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

export default function WhatsNew() {
  const [releases, setReleases] = useState(null);
  useEffect(() => { api.get("/releases").then(r => setReleases(r.data.releases)).catch(() => setReleases([])); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 space-y-8" data-testid="whats-new-page">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Release notes</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">What's New</h1>
        <p className="opacity-60 text-sm mt-1">Everything released to the club app, newest first.</p>
      </div>
      {releases === null ? <div className="opacity-50 font-display tracking-widest">LOADING…</div>
        : releases.length === 0 ? <div className="card-tactical rounded-md p-10 text-center opacity-60">No release notes yet.</div>
        : (
          <ol className="relative border-l border-border ml-2 space-y-8" data-testid="releases-list">
            {releases.map((r, idx) => (
              <li key={r.id} className="pl-6 relative" data-testid={`release-${r.id}`}>
                <span className={`absolute -left-[7px] top-1.5 w-3 h-3 rounded-full ${idx === 0 ? "bg-[#83B68B]" : "bg-border"}`} />
                <div className="flex flex-wrap items-baseline gap-3">
                  <span className="font-display font-black text-2xl">v{r.version}</span>
                  {idx === 0 && <span className="text-[9px] tracking-widest uppercase px-2 py-0.5 rounded border border-[#83B68B]/50 text-[#83B68B] inline-flex items-center gap-1"><Sparkles className="w-3 h-3" /> Latest</span>}
                  <span className="text-xs opacity-60">{(() => { try { return format(parseISO(r.date), "d MMM yyyy"); } catch { return r.date; } })()}</span>
                </div>
                <div className="font-semibold mt-1">{r.title}</div>
                <ul className="mt-2 space-y-1.5 text-sm opacity-90 list-disc pl-5">{r.items.map((it, i) => <li key={i}>{it}</li>)}</ul>
              </li>
            ))}
          </ol>
        )}
    </div>
  );
}
